<template>
  <div>
    <a-modal v-model="visible" :bodyStyle="{ padding: 0 }" class="modal_main" @cancel="CancelModal" :footer="null" width="470px" height="141px">
      <div class="circle_container d-flex flex-row 0">
        <div class="left-toast">
          <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.25 0.75H2.75C1.34375 0.75 0.25 1.88281 0.25 3.25V15.75C0.25 17.1562 1.34375 18.25 2.75 18.25H15.25C16.6172 18.25 17.75 17.1562 17.75 15.75V3.25C17.75 1.88281 16.6172 0.75 15.25 0.75ZM8.0625 5.4375C8.0625 4.92969 8.45312 4.5 9 4.5C9.50781 4.5 9.9375 4.92969 9.9375 5.4375V10.4375C9.9375 10.9844 9.50781 11.375 9 11.375C8.45312 11.375 8.0625 10.9844 8.0625 10.4375V5.4375ZM9 15.125C8.29688 15.125 7.75 14.5781 7.75 13.9141C7.75 13.25 8.29688 12.7031 9 12.7031C9.66406 12.7031 10.2109 13.25 10.2109 13.9141C10.2109 14.5781 9.66406 15.125 9 15.125Z"
              fill="#2A71D4"
            />
          </svg>
        </div>

        <div class="right-toast">
          <h3 :style="{ 'font-weight': '700', 'font-size': '14px', 'line-height': '21px' }">
            Physician Added to circle
          </h3>
          <p :style="{ 'font-weight': '400', 'font-size': '14px', 'line-height': '21px', color: '#647490' }">
            You can add as many physicians to your circle as you please.
            <br />
            Would you like to search for another physician
          </p>
          <div class="d-flex flex-row " :style="{ gap: '24px', 'margin-bottom': '0px' }">
            <p @click="closeModal" class="cp circle-btn" :style="{ color: getPrimaryColor() }">
              No Thanks
            </p>
            <p @click="SearchPhy" class="cp circle-btn" :style="{ color: getPrimaryColor() }">
              Search Physician
            </p>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: "AddToCircle",
  data() {
    return { visible: false }
  },
  methods: {
    show() {
      this.visible = !this.visible
    },
    closeModal() {
      this.visible = false
    },
    SearchPhy() {
      this.$router.push({ path: `/${this.currentCircle.condition_type}/home/medicaldirectories/physicians` })
    },
  },
}
</script>

<style lang="scss" scoped>
.modal_main .ant-modal {
  /* margin-left: 935px; */
  margin-right: 63px;
}
.circle_container {
  height: 141px;
  width: 470px;
  background: #ffffff;
  border: 1px solid #2a71d4;
  border-radius: 4px;
  padding: 19px;
  margin-top: 32px;
}
.left-toast {
  margin-right: 11.5px;
}
.circle-btn {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/AddToCircle.vue